'use strict';
var DataStore = require('./util/datastore'),
    constants = require('./constants'),
    button = require('./button'),
    css = require('browserlib').css,
    form = require('./form'),
    QR = require('./qr'),
    dynamic = require('./util/dynamic'),
    assign = require('./util/assign'),
    checkoutConfig = require('./util/checkout-config'),
    hasCss = false;

function sanitizeNumber(obj) {
    return !isNaN(parseFloat(obj)) && parseFloat(obj);
}

function solveConstraints(data, attrName) {
    if (data.get(attrName)) {
        var attrNum = sanitizeNumber(data.pluck(attrName)),
            min = constants.LIMITS[attrName].min,
            max = constants.LIMITS[attrName].max;
        return Math.min(Math.max(attrNum, max), min);
    }
}
module.exports = function factory(business, raw, config, parent) {
    var data, wrapper, html, key, label, type;
    var buttonEl, requestedHeight, requestedWidth, finalHeight, finalWidth, renderedWidth, heightWidthRatio,
        dynamicCssModel, tagLineEl, tagLineHeight, locale;
    if (!business) {
        return false;
    }

    // Normalize incoming data if needed
    if (raw.items) {
        data = raw;
    } else {
        data = new DataStore();
        for (key in raw) {
            if (raw.hasOwnProperty(key)) {
                data.add(key, raw[key]);
            }
        }
    }
    // sanitize and validate length and width
    requestedWidth = solveConstraints(data, 'width');
    requestedHeight = solveConstraints(data, 'height');
    // Defaults
    config = config || {};
    label = config.label || constants.DEFAULT_LABEL;
    type = config.type || constants.DEFAULT_TYPE;
    locale = data.get('lc') || constants.DEFAULT_LOCALE;
    
    //special case labels
    switch (label) {
    case 'checkout':
        assign(config, checkoutConfig.getConfig(label, data, config, locale));
        break;
    case 'credit':
        config.style = 'quaternary';
        break;
    default:
        if (config.style === 'checkout') {
          assign(config, checkoutConfig.getConfig(label, data, config, locale));
        }
        break;
    }
    //special case button types
    var specials = ['cart', 'donate', 'subscribe'];
    switch (type) {
    case 'cart':
        data.add('cmd', '_cart');
        data.add('add', true);
        break;
    case 'donate':
        data.add('cmd', '_donations');
        break;
    case 'subscribe':
        data.add('cmd', '_xclick-subscriptions');
        if (data.get('amount') && !data.get('a3')) {
            data.add('a3', data.pluck('amount'));
        }
        break;
    default:
        break;
    }

    if (specials.indexOf(type) === -1) {
        // Buy Now
        if (data.get('hosted_button_id')) {
            data.add('cmd', '_s-xclick');
        } else {
            data.add('cmd', '_xclick');
        }
    }
    // Add common data
    data.add('business', business);
    data.add('bn', constants.BN_CODE.replace(/\{label\}/, label));
    // Inject the CSS onto the page
    if (!hasCss) {
        hasCss = true;
        css.inject(document.getElementsByTagName('head')[0], constants.STYLES);
    }
    // If there is *either* a custom width or height,
    // then set the size to large and calculate an approximate ratio
    // first with the given label
    if (type !== 'qr' && (requestedHeight || requestedWidth)) {
        config.size = 'large'; // baseline for ratio
        wrapper = document.createElement('span');
        wrapper.className = constants.WIDGET_NAME;
        wrapper.innerHTML = button(label, data, config, locale);
        wrapper.style.visibility = 'hidden';
        parent.appendChild(wrapper);
        buttonEl = wrapper.children[0];
        heightWidthRatio = (buttonEl.offsetHeight - 2) / buttonEl.offsetWidth; // -2 because borders
        tagLineEl = wrapper.querySelectorAll('paypal-button-tag-content');
        tagLineHeight = tagLineEl[0] ? tagLineEl[0].offsetHeight : 0;
        parent.removeChild(wrapper);
        // now, if the height is not given, we calculate an optimal height given the width
        // otherwise we just use the supplied height
        finalHeight = requestedHeight || Math.floor(requestedWidth * heightWidthRatio);
        data.add('height', finalHeight.toString());
        // the width is either what's specified or interpolated
        finalWidth = requestedWidth || Math.floor(finalHeight / heightWidthRatio);
        data.add('width', finalWidth.toString());
        //Base on product requirement, dimensions of checkout buttons are fixed (doesn't allow dynamic changes)
        if (label !== 'checkout' && config.style !== 'checkout') {
            // we generate some dynamic CSS largely based on the height
            dynamicCssModel = dynamic.cssModelUsing(finalHeight, finalWidth, tagLineHeight);
            css.inject(document.getElementsByTagName('head')[0], dynamic.generateCssUsing(dynamicCssModel));
            // we again re-insert the element to determine the actual width
            wrapper.innerHTML = button(label, data, config, locale);
            parent.appendChild(wrapper);
            buttonEl = wrapper.children[0];
            renderedWidth = buttonEl.offsetWidth;
            parent.removeChild(wrapper);
            // if the final result is not as long as requested, we pad it
            if (requestedWidth && requestedWidth > renderedWidth) {
                dynamicCssModel.contentPaddingRight = dynamicCssModel.contentPaddingRight + Math.floor((finalWidth - renderedWidth) / 2);
                dynamicCssModel.contentPaddingLeft = dynamicCssModel.contentPaddingLeft + Math.ceil((finalWidth - renderedWidth) / 2);
            }
            // we are done, and inject the corrected CSS
            css.inject(document.getElementsByTagName('head')[0], dynamic.generateCssUsing(dynamicCssModel));
        }
    }
    // Build the UI components
    if (type === 'qr') {
        html = QR(data, config);
    } else if (type === 'button') {
        html = button(label, data, config, locale);
    } else {
        html = form(label, data, config);
    }
    // Wrap it up all nice and neat and return it
    wrapper = document.createElement('span');
    wrapper.className = constants.WIDGET_NAME;
    wrapper.innerHTML = html;
    return {
        label: label,
        type: type,
        el: wrapper
    };
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/factory.js
 ** module id = 4
 ** module chunks = 0
 **/